import slugify from "@sindresorhus/slugify";
import clsx from "clsx";

import { ICommentDTO, UserPremiumType } from "types";
export { clsx as cx, slugify };

export function calculateTotalCommentsSize(comments: ICommentDTO[]): number {
    let totalSize = 0;
    for (const comment of comments) {
        totalSize += 1; // Count the current comment
        if (comment.replies && comment.replies.length > 0) {
            // Recursively count replies
            totalSize += calculateTotalCommentsSize(comment.replies);
        }
    }
    return totalSize;
}

// lib/loadScript.ts
export function loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
        // Check if the script is already loaded
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
        }

        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () =>
            reject(new Error(`Failed to load script ${src}`));
        document.body.appendChild(script);
    });
}

const subscriptionStylesWithoutAnimation = {
    [UserPremiumType.NONE]: "border border-slate-400",
    [UserPremiumType.BASIC]: "border-2 border-sky-700",
    [UserPremiumType.PLUS]: "border-2 border-red-600",
    [UserPremiumType.PRO]: "border-2 border-red-600 animate-subtlePulse",
    [UserPremiumType.ELITE]:
        "p-[3px] bg-gradient-to-r from-emerald-500 via-amber-600 to-sky-500 animate-subtlePulse",
    [UserPremiumType.ULTIMATE]:
        "p-[3px] bg-gradient-to-r from-[#0268A3] via-red-600 to-amber-500 animate-gradient animate-subtlePulse",
};

const subscriptionStylesWithAnimation = {
    ...subscriptionStylesWithoutAnimation,
    [UserPremiumType.PRO]: "border-2 border-red-600 animate-subtlePulse",
    [UserPremiumType.ELITE]:
        "p-[3px] bg-gradient-to-r from-emerald-500 via-amber-600 to-sky-500 animate-subtlePulse",
    [UserPremiumType.ULTIMATE]:
        "p-[3px] bg-gradient-to-r from-[#0268A3] via-red-600 to-amber-500 animate-gradient animate-subtlePulse",
};

export function getSubscriptionStyle(
    subscriptionType: UserPremiumType,
    animate?: boolean
) {
    return animate
        ? subscriptionStylesWithAnimation[subscriptionType]
        : subscriptionStylesWithoutAnimation[subscriptionType];
}
